import hljs from 'highlight.js';
import 'highlight.js/styles/atom-one-dark.css';

window.hljs = hljs;
